import Emitter from './Emitter'

export const EVENT_CHANGE = 'change'
export const EVENT_ADD_TRACK = 'addtrack'
export const EVENT_REMOVE_TRACK = 'removetrack'

class AudioTrackList extends Emitter {
  constructor () {
    super()

    this._length = 0

    this.addEventListener(EVENT_ADD_TRACK, e => {
      if (typeof this.onaddtrack === 'function') {
        this.onaddtrack(e)
      }
    })
    this.addEventListener(EVENT_CHANGE, e => {
      if (typeof this.onchange === 'function') {
        this.onchange(e)
      }
    })
    this.addEventListener(EVENT_REMOVE_TRACK, e => {
      if (typeof this.onremovetrack === 'function') {
        this.onremovetrack(e)
      }
    })
  }

  get length () {
    return this._length
  }

  set length (value) {
    while (this._length > value) {
      delete this[--this._length]
    }
  }

  /**
   * Add an audio track
   *
   * @param {AudioTrack} track
   * @returns {void}
   */
  addTrack (track) {
    let enabledId = -1
    track.list = this

    for (let i = 0; i < this._length; i++) {
      if (this[i].id === track.id) {
        track._enabled = this[i]._enabled
        this[i] = track
        return
      }
      if (this[i]._enabled) {
        enabledId = i
      }
    }
    this[this._length++] = track

    const e = Emitter.createEvent('Event', EVENT_ADD_TRACK, { track: track })
    this.dispatchEvent(e)

    if ((track.enabled) && (enabledId >= 0)) {
      this.setActiveTrack(track)
    }
  }

  getTrackById (id) {
    for (let i = 0; i < this._length; i++) {
      if (this[i].id === id) {
        return this[i]
      }
    }
    return null
  }

  setActiveTrack (track) {
    for (let i = 0; i < this._length; i++) {
      this[i].enabled = this[i] === track
    }
    const e = Emitter.createEvent('Event', EVENT_CHANGE, { track: track })
    this.dispatchEvent(e)
  }
}

export default AudioTrackList
